import { CalendarCheck2 } from 'lucide-react';
import { cn } from '@agenda-facil/ui';

export function Brand({ compact = false, className }: { compact?: boolean; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-3 font-extrabold tracking-[-0.03em]', className)}>
      <span className="grid size-10 place-items-center rounded-[14px] bg-[var(--brand)] text-[var(--brand-foreground)] shadow-[var(--shadow-sm)]">
        <CalendarCheck2 size={21} strokeWidth={2.4} />
      </span>
      {!compact && (
        <span className="text-[1.03rem] leading-none">
          Agenda <span className="text-[var(--accent)]">Fácil</span>
        </span>
      )}
    </span>
  );
}
